import axios from 'axios';

function getCallerUrl(): string {
  return window.location.hostname;
}

export interface FAQCategory {
  id: number;
  descricao: string;
}

export interface FAQQuestion {
  id: number | string;
  pergunta: string;
  resposta: string;
}

export interface FAQItemDisplay {
  category: string;
  question: string;
  answer: string;
}

export async function fetchFAQCategories(middlewareUrl: string): Promise<FAQCategory[]> {
  const response = await axios.get<FAQCategory[]>(`${middlewareUrl}/faq/categorias`, {
    headers: {
      'Content-Type': 'application/json',
      'x-caller-url': getCallerUrl(),
    },
  });
  return response.data;
}

export async function fetchFAQQuestions(middlewareUrl: string, categoryId: number): Promise<FAQQuestion[]> {
  const response = await axios.get<FAQQuestion[]>(`${middlewareUrl}/faq/categoria/${categoryId}`, {
    headers: {
      'Content-Type': 'application/json',
      'x-caller-url': getCallerUrl(),
    },
  });
  return response.data;
}

export async function fetchAllFAQs(middlewareUrl: string): Promise<FAQItemDisplay[]> {
  try {
    const categories = await fetchFAQCategories(middlewareUrl);

    let allItems: FAQItemDisplay[] = [];

    for (const cat of categories) {
      try {
        const questions = await fetchFAQQuestions(middlewareUrl, cat.id);
        const mapped = questions.map(q => ({
          category: cat.descricao,
          question: q.pergunta,
          answer: q.resposta,
        }));
        allItems = [...allItems, ...mapped];
      } catch (err) {
        console.error(`Erro ao buscar perguntas da categoria ${cat.descricao}:`, err);
      }
    }

    return allItems;
  } catch (err) {
    console.error('Erro ao buscar FAQ:', err);
    return [];
  }
}
